import { PagePending } from "@/components/ui/PagePending";
import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { date, fallback, number, object, optional, picklist, pipe, string, toMinValue } from "valibot";

export const Route = createFileRoute("/admin/claims/")({
  pendingComponent: PagePending,
  component: lazyRouteComponent(() => import("./+Claims")),
  validateSearch: object({
    page: fallback(pipe(optional(number(), 1), toMinValue(1)), 1),
    "page-size": fallback(pipe(optional(number(), 100), toMinValue(10)), 100),
    member: fallback(optional(string()), undefined),
    id: fallback(optional(string()), undefined),
    vendor: fallback(optional(string()), undefined),
    status: fallback(optional(picklist(["pending", "reviewing", "approved", "declined", "paid"])), undefined),
    start: fallback(pipe(optional(date())), undefined),
    end: fallback(pipe(optional(date())), undefined),
  }),
  head: () => ({ meta: seo({ title: "Claim Review" }) }),
});
